import React from 'react';
import './styles.css';
import { currencyFormat } from '../../../../utils';

function ContainerPriceDinamic({
  price,
  toBuy
}) {

  return (
    <div className='sectionPriceDinamicContainer'>
      <div className='sectionPriceDinamic'>
        <p className='textBig'>
          <span className='textMediun'>{currencyFormat(0).currency}</span>
          {currencyFormat(price?.fareAmount).value}
        </p>
        <p className='textMediun'>impuestos:</p>
        <p className='textMediun'>{currencyFormat(price?.taxAmount).total}</p>
        <p className='textSmall'>Precio final con impuestos: <span className='textSmallWeight'>{currencyFormat(price?.totalAmount).total}</span>
        </p>
        <div className='btn' onClick={() => toBuy(false)}>
          <p className='btnText'>COMPRAR</p>
        </div>
      </div>
    </div>
  )
}

export default ContainerPriceDinamic;
